import Api from '@/services/Api'

export default {
  index () {
    return Api().get('/getmembership')
  },
  getmembershipbyid (id) {
    return Api().get(`/getmembershipbyid/${id}`)
  },
  KidsByFamilyId(id) {
    return Api().get(`/kids/getByFamilyId/${id}`)
  },
  spouseByFamilyId(id) {
    return Api().get(`/spouse/getByFamilyId/${id}`)
  },
  getmemberbyemailAddress (id) {
    return Api().get(`/getmemberbyemail/${id}`)
  },
  getCategory () {
    return Api().get(`/categorylist`)
  },
  getCategory1() {
    return Api().get(`/categorylist`)
  },
  getmemberbyemail (id) {
    return Api().get(`/getmemberbyemail/${id}`)
  },
  getPaymentHistory (email) {
    return Api().get(`/getPaymentHistory/${email}`)
  },
  addmembership (comment) {
    return Api().post('/addmembership', comment)
  },
  updatemembership (comment) {
    return Api().post('/updatemembership', comment)
  },
  deleteMembership (id) {
    return Api().post(`/deleteMembership/${id}`)
  },
  getConfigData () {
    return Api().get('/getConfigData')
  },
  addrole (comment) {
    return Api().post('/addrole', comment)
  },
  getrolebyid (id) {
    return Api().get(`/getrolebyid/${id}`)
  },
  getRoleByEmail (email) {
    return Api().get(`/getRoleByEmail/${email}`)
  },
  updaterole (comment) {
    return Api().post('/updaterole', comment)
  },
  deleterole (id) {
    return Api().post(`/deleterole/${id}`)
  },
  getevents () {
    return Api().get('/event/getevents')
  },  
  geteventbyid (id) {
    return Api().get(`/event/geteventbyid/${id}`)
  },
  addevent (event) {
    return Api().post('/event/addevent', event)
  },
  updateevent (event) {
    return Api().post('/event/updateevent', event)
  },
  updateCulturalProgramEnrollmentDates (enrollmentDates) {
    return Api().post('/event/updateCulturalProgramEnrollmentDates', enrollmentDates)
  },
  updateCompetitiveProgramEnrollmentDates (enrollmentDates) {
    return Api().post('/event/updateCompetitiveProgramEnrollmentDates', enrollmentDates)
  },
  insertCulturalProgram (culturalProgram) {
    return Api().post('/event/insertCulturalProgram', culturalProgram)
  },
  updateCulturalProgram (culturalProgram) {
    return Api().post('/event/updateCulturalProgram', culturalProgram)
  },
  deleteCulturalProgram (culturalProgram) {
    return Api().post('/event/deleteCulturalProgram', culturalProgram)
  },
  getLookupsForCulturalPrograms () {
    return Api().get('/event/getLookupsForCulturalPrograms')
  },

  insertCompetitiveProgram (culturalProgram) {
    return Api().post('/event/insertCompetitiveProgram', culturalProgram)
  },
  updateCompetitiveProgram (culturalProgram) {
    return Api().post('/event/updateCompetitiveProgram', culturalProgram)
  },
  deleteCompetitiveProgram (culturalProgram) {
    return Api().post('/event/deleteCompetitiveProgram', culturalProgram)
  },
  getLookupsForCompetitivePrograms () {
    return Api().get('/event/getLookupsForCompetitivePrograms')
  },  
  insertFoodSale (event) {
    return Api().post('/event/'+ event._id + '/foodsale' , event.foodsale)
  },
  updateFoodSale (event) {
    return Api().put ('/event/'+ event._id + '/foodsale', event.foodsale)
  },
  deleteFoodSale (event) {
    return Api().delete('/event/'+ event.eventid + '/foodsale' + '/' + event.foodsaleid)
  },
  insertTicketSale (event) {
    return Api().post('/event/'+ event._id + '/ticketsale' , event.ticketsale)
  },
  updateTicketSale (event) {
    return Api().put ('/event/'+ event._id + '/ticketsale', event.ticketsale)
  },
  deleteTicketSale (event) {
    return Api().delete('/event/'+ event.eventid + '/ticketsale' + '/' + event.ticketsaleid)
  },

  deleteevent (id) {
    return Api().post(`/event/deleteevent/${id}`)
  },
  createProgram(program) {
    return Api().post(`/program/create`,program)
  },
  programICoordinate(id) {
    return Api().get(`/programICoordinate/${id}`)
  },
  programByFamilyID(id) {
    return Api().get(`/programByFamilyID/${id}`)
  },
  addKid(kid) {
    return Api().post(`/kids/create`,kid)
  },
  programsByEventID(id) {
    return Api().get(`/program/${id}`)
  },
  updateProgram(program) {
    return Api().post('/program/update', program)
  },
  getSpouseByFamilyId(familyid) {
    return Api().get(`/getspousedata/${familyid}`)
  },
  updateSpouseData (spouse) {
    return Api().post('/spouse/updateSpouseData', spouse)
  },
  createSpouseData (spouse) {
    return Api().post('/spouse/create', spouse)
  },
  getactiveEvents() {
    return Api().get('/activeEvents')
  },
  participantsByProgramID(id) {
    return Api().get(`/participant/${id}`)
  },
  getAllKids() {
    return Api().get('/kids/')
  },
  getAllSpouses() {
    return Api().get('/spouse/')
  },  
  getprogrambyid(id) {
    return Api().get(`/programById/${id}`)
  },
  getProgramBySPN(id) {
    return Api().get(`/SystemProNumber/${id}`)
  },
  pcpcheckinsbyprogram() {
    return Api().get('/event/pcpcheckinsbyprogram')
  },
  getParticipantsByProgramId(id) {
    return Api().get(`/getParticipantsByProgramId/${id}`)
  },
  //byFamilyId
  getAllParticipantByFamilyId(id) {
    return Api().get(`/participant/byFamilyId/${id}`)
  },
  getAllParticipantByProgramId(id) {
    return Api().get(`/participant/byProgramId/${id}`)
  },
  getAllParticipantByPaymentStatus(id) {
    return Api().get(`/participant/paymentstatus/${id}`)
  },
  //byProgramId
  getAllParticipantByMembership(id) {
    return Api().get(`/participant/membershipCategory/${id}`)
  },
  deleteParticipant(id) {
    return Api().put(`/participant/delete/${id}`)
  },
  updateEnrollmentStatus (newValue) {
    return Api().post(`/updateEnrollmentStatus/${newValue}`)
  },
  getEnrollmentStatus () {
    return Api().get(`/getEnrollmentStatus`)
  },
  getParticipantsByKidsId(id) {
    return Api().get(`/getParticipantsByKidsId/${id}`)
  },  
  createParticipantData(participantData) {
    return Api().post(`/participant/createParticipant`,participantData)
  },
  getAllKuralInfo () {
    return Api().get(`/getAllKuralInfo`)
  },
  getKuralById(id) {
    return Api().get(`/getKuralById/${id}`)
  }, 
  updateKuralById (data) {
    return Api().post('/updateKuralById', data)
  },
  updateKural (data) {
    return Api().post('/updateKural', data)
  },
  sendEmailAlert (data) {
    return Api().post('/sendEmailAlert', data)
  },
  getStats (year) {
    return Api().get(`/getStats/${year}`)
  },
  submitToContactUs (comment) {
    return Api().post('/submitToContactUs', comment)
  },
  addFamilyDetails (obj) {
    return Api().post('/addFamilyDetails', obj)
  },
  getAllFamilyMembers (email) {
    return Api().get(`/getAllFamilyMembers/${email}`)
  },
  getFamilyByID (id) {
    return Api().get(`/getFamilyByID/${id}`)
  },
  deleteFamilyMembership (id) {
    return Api().post(`/deleteFamilyMembership/${id}`)
  },
  updateFamilyMember (obj) {
    return Api().post('/updateFamilyMember', obj)
  },
  getAllMemberDetails (id) {
    return Api().get(`/getAllMemberDetails/${id}`)
  },
  submitSubscription (email) {
    return Api().post(`/submitSubscription/${email}`)
  },
  getSubscribers () {
    return Api().get(`/getSubscribers`)
  },
  deleteSubscriber (id) {
    return Api().post(`/deleteSubscriber/${id}`)
  },
  submitFDCheckIn (checkinstatusdetails) {
    return Api().post('submitFDCheckIn', checkinstatusdetails)
  },
  getFDstatus () {
    return Api().get('/getFDstatus')
  },
  getCount () {
    return Api().get('/getCount')
  },
  deleteCheckIn (id) {
    return Api().post(`/deleteCheckIn/${id}`)
  },
  getAllGalleryInfo () {
    return Api().get(`/getAllGalleryInfo`)
  },
  getGalleryById (id) {
    return Api().get(`/getGalleryById/${id}`)
  },
  updateGalleryById (obj) {
    return Api().post('/updateGalleryById', obj)
  },
  deleteGalleryById (id) {
    return Api().post(`/deleteGalleryById/${id}`)
  },
  addGallery (obj) {
    return Api().post('/addGallery', obj)
  },
  getUploadedFiles(bucket, folder) {
		return Api().get(`/getUploadedFiles/${bucket}/${folder}`)
	},
	deleteS3File(bucket, key) {
		return Api().get(`/deleteS3File/${bucket}/${key}`)
	},
	uploadfile(payload, bucket, folder, email) {
		return Api().post(`/uploadfile/${bucket}/${folder}/${email}`, payload)
	},
	renameS3File(bucket, oldKey, newKey) {
		return Api().get(`/renameS3File/${bucket}/${oldKey}/${newKey}`)
	},
	getFoldersFromS3(bucket) {
		return Api().get(`/getFoldersFromS3/${bucket}`)
	},
	createFolder(bucket, folder) {
		return Api().get(`/createFolder/${bucket}/${folder}`)
	},
	getS3Buckets() {
		return Api().get(`/getS3Buckets`)
	},
	getMetadata(bucket, key) {
		return Api().get(`/getMetadata/${bucket}/${key}`)
	},
  addVolunteerInfo (obj) {
    return Api().post('/addVolunteerInfo', obj)
  },
  getVolunteerInfo () {
    return Api().get(`/getVolunteerInfo`)
  },
  getVolunteerById (id) {
    return Api().get(`/getVolunteerById/${id}`)
  },
  updateVolunteerInfo (obj) {
    return Api().post('/updateVolunteerInfo', obj)
  },
  deleteVolunteerById (id) {
    return Api().post(`/deleteVolunteerById/${id}`)
  },
  validateMembership (email) {
    return Api().get(`/validateMembership/${email}`)
  },
  reserveCountForEvent (obj) {
    return Api().post('/reserveCountForEvent', obj)
  },
  getMembershipCount () {
    return Api().get(`/getMembershipCount`)
  },
  deleteEventData (id) {
    return Api().post(`/deleteEventData/${id}`)
  },
  updateEventData (obj) {
    return Api().post('/updateEventData', obj)
  },
  getEventById (id) {
    return Api().get(`/getEventById/${id}`)
  },
  sendBulkEmail(comment) {
		return Api().post('/sendBulkEmail', comment)
	},
  getParticipants () {
    return Api().get(`/getParticipants`)
  },
  updateParticipants (obj) {
    return Api().post('/updateParticipants', obj)
  },
  removeCheckIn (id) {
    return Api().post(`/removeCheckIn/${id}`)
  },
  validateProgramId (PID) {
    return Api().get(`/validateProgramId/${PID}`)
  },
  programChanges (obj) {
    return Api().post('/programChanges', obj)
  },
  getProgramChanges(){
     return Api().get('/getProgramChanges')
  },
  getPaariVallalMembers(){
    return Api().get('/getPaariVallalMembers')
 },
  getEventReservation (email) {
    return Api().get(`/getEventReservation/${email}`)
  },
  reserveFoodForEvent (obj) {
    return Api().post('/reserveFoodForEvent', obj)
  },
  getMyProgramByID (id) {
    return Api().get(`/getMyProgramByID/${id}`)
  },
  updateMyProgram (obj) {
    return Api().post('/updateMyProgram', obj)
  },
  reserveCountForViV (obj) {
    return Api().post('/reserveCountForViV', obj)
  },
  reserveCountForSpecialEvent (obj) {
    return Api().post('/reserveCountForSpecialEvent', obj)
  },
  getParticipantsByEmail (id) {
    return Api().get(`/getParticipantsByEmail/${id}`)
  },
  getMembershipForCheckIn() {
    return Api().get('/getMembershipForCheckIn')
  },
  addVolleyBallDetails (obj) {
    return Api().post('/addVolleyBallDetails', obj)
  },
  getVolleyBallDetails() {
    return Api().get('/getVolleyBallDetails')
  },
  deleteVolleyBallDetails (id) {
    return Api().post(`/deleteVolleyBallDetails/${id}`)
  },
  getZoneSwitch (id) {
    return Api().get(`/getZoneSwitch/${id}`)
  },  
  updateZoneSwitch (obj) {
    return Api().post('/updateZoneSwitch', obj)
  },
  getSponsors(){
    return Api().get('/getSponsors')
  },
  addSponsor (obj) {
    return Api().post('/addSponsor', obj)
  },
  deleteSponsor (id) {
    return Api().delete(`/deleteSponsor/${id}`)
  },
  updateSponsor (id, obj) {
    return Api().post(`/updateSponsor/${id}`, obj)
  },
  getCommitteeByYear (year) {
    return Api().get(`/committee/${year}`)
  }
}